import { render, staticRenderFns } from "./ProductDetailsModal.vue?vue&type=template&id=ec63748a&scoped=true&"
import script from "./ProductDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailsModal.vue?vue&type=style&index=0&id=ec63748a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec63748a",
  null
  
)

export default component.exports